'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fixCursorStyle = require('./fixCursorStyle');

var _fixCursorStyle2 = _interopRequireDefault(_fixCursorStyle);

var TranshandDesign = (function (_React$Component) {
  _inherits(TranshandDesign, _React$Component);

  function TranshandDesign() {
    _classCallCheck(this, TranshandDesign);

    _get(Object.getPrototypeOf(TranshandDesign.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(TranshandDesign, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var rotateFingerDist = _props.rotateFingerDist;
      var originRadius = _props.originRadius;
      var stroke = _props.stroke;
      var getHitEvents = _props.getHitEvents;
      var coordinator = _props.coordinator;
      var cursor = _props.cursor;
      var points = _props.points;
      var pOrigin = _props.pOrigin;
      var transformTypes = _props.transformTypes;
      var p = points.map(function (point) {
        return coordinator.localToGlobal(point);
      });
      var po = coordinator.localToGlobal(pOrigin);
      var or = originRadius;

      var boxHitPoints = p[0].x + ' ,' + p[0].y + ' ' + (p[1].x + ' ,' + p[1].y + ' ') + (p[2].x + ' ,' + p[2].y + ' ') + (p[3].x + ' ,' + p[3].y);

      function renderOrigin() {
        if (transformTypes.indexOf('origin') !== -1) {
          return [_react2['default'].createElement('line', _extends({ key: 'h', x1: po.x - or, y1: po.y, x2: po.x + or, y2: po.y }, stroke)), _react2['default'].createElement('line', _extends({ key: 'v', x1: po.x, y1: po.y - or, x2: po.x, y2: po.y + or }, stroke))];
        } else {
          return null;
        }
      }

      return _react2['default'].createElement(
        'g',
        null,
        _react2['default'].createElement('polygon', _extends({
          fill: 'none'
        }, stroke, {
          points: boxHitPoints })),
        renderOrigin(),
        _react2['default'].createElement('polygon', _extends({ ref: 'boxHit',
          fill: 'black', opacity: '0',
          stroke: 'black',
          strokeLinejoin: 'round',
          strokeLocation: 'outside',
          strokeWidth: rotateFingerDist,
          points: boxHitPoints,
          style: {
            cursor: cursor,
            pointerEvents: 'auto'
          }
        }, getHitEvents())),
        _react2['default'].createElement('circle', _extends({ ref: 'originHit',
          fill: 'black', opacity: '0',
          cx: po.x,
          cy: po.y,
          r: originRadius,
          style: {
            cursor: cursor,
            pointerEvents: 'auto'
          }
        }, getHitEvents()))
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _fixCursorStyle2['default'])(this.refs.boxHit, this.props.cursor); //HACK
      (0, _fixCursorStyle2['default'])(this.refs.originHit, this.props.cursor); //HACK
    }
  }]);

  return TranshandDesign;
})(_react2['default'].Component);

exports['default'] = TranshandDesign;
module.exports = exports['default'];
//# sourceMappingURL=TranshandDesign.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/TranshandDesign.js
 ** module id = 3288
 ** module chunks = 0
 **/